import MomSysMstMaterial from "./MomSysMstMaterial";

function MomSysMstMaterialInfo ( props ) {

    return <MomSysMstMaterial id="MomSysMstMaterial" />;

}

export default MomSysMstMaterialInfo;
